// extracted by mini-css-extract-plugin
export var cardIcon = "_7m-4";
export var checkboxCard = "_7m-0";
export var checkboxCardSelected = "_7m-3";
export var disabled = "_7m-1";
export var outerBorder = "_7m-2";
export var spacerMedium = "_7m-7";
export var spacerSmall = "_7m-6";
export var spacerXsmall = "_7m-5";